import { render, staticRenderFns } from "./pet-exercise-container.vue?vue&type=template&id=37c14278&scoped=true&lang=pug"
import script from "./pet-exercise-container.js?vue&type=script&lang=js&external"
export * from "./pet-exercise-container.js?vue&type=script&lang=js&external"
import style0 from "./pet-exercise-container.vue?vue&type=style&index=0&id=37c14278&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37c14278",
  null
  
)

export default component.exports